import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";

const RevenuePaymentMethodReportForm = () => {
  const [formData, setFormData] = useState({
    startDate: '2024-09-01',
    endDate: '2024-09-30',
    details: false,
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px' ,marginLeft:"0px"}}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Start Date */}
          <Form.Group as={Row} controlId="startDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose a start date to report on">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* End Date */}
          <Form.Group as={Row} controlId="endDate" className="mb-3">
            <Form.Label column sm="4" title="Please choose an end date to report on">
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                required
              />
            </Col>
          </Form.Group>

          {/* Include Transaction Details Checkbox */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">&nbsp;</Form.Label>
            <Col sm="8">
              <Form.Check
                type="checkbox"
                name="details"
                checked={formData.details}
                onChange={handleChange}
                label="Include Transaction Details?"
                className="ms-0"
              />
            </Col>
          </Form.Group>

          {/* Format Selection */}
          <Form.Group as={Row} controlId="format" className="mb-3">
            <Form.Label column sm="4" title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="form-select"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row} className="mb-0">
                     <Col sm={{ span: 8, offset: 4 }}>
                     <Link to="/Addpaymentmethod">
                       <Button
                         type="submit"
                         variant="primary"
                         className="w-100"
                         style={{
                           backgroundColor: '#004aad',
                           borderColor: '#004aad',
                           marginTop: '10px',
                         }}
                       >
                         <span className="ico-search"></span> Run
                       </Button>
                       </Link>
                     </Col>
                   </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default RevenuePaymentMethodReportForm;
